import {
  fetchBillingSummary,
  type BillingSummaryResponse
} from "../api/billingApi";
import { useApiQuery } from "../../../hooks/useApiQuery";
import { useCallback } from "react";

export function useBillingSummary() {
  const queryFn = useCallback((token: string) => fetchBillingSummary(token), []);
  return useApiQuery<BillingSummaryResponse>({
    queryFn
  });
}
